/* =============================================================================
Navigation event handling
============================================================================= */

require('swiped-events');

// eslint-disable-next-line space-before-function-paren
(function() {
    /* =================================================
    All navs.
    =================================================== */
    // Do not follow hash links or those opening a submenu.
    const deadLinks = document.querySelectorAll(
        '.nav li:not(.rs-modal-link) > a[href="#"], .nav .menu-item-has-children > a'
    );
    Array.from(deadLinks).forEach(link =>
        link.addEventListener('click', e => e.preventDefault())
    );

    const header = document.querySelector('.rs-header');
    const hello = document.querySelector('.rs-hello-bar');
    // Flag navbar with class when page scrolled.
    if (window.requestAnimationFrame) {
        // Gets the scroll position.
        let curScrollY;
        let lastScrollY = window.scrollY;
        const offsetVal = hello ? hello.offsetHeight : 40;

        const onScroll = () => {
            // Style navbar when scrolled a minimum distance.
            if (
                curScrollY >= offsetVal &&
                !header.classList.contains('rs-header--is-sticky')
            ) {
                header.classList.add('rs-header--is-sticky');
            } else if (
                curScrollY < offsetVal &&
                header.classList.contains('rs-header--is-sticky')
            ) {
                header.classList.remove('rs-header--is-sticky');
            }
        };

        // Fire "onScroll" only when window is scrolled vertically.
        const rafLoop = () => {
            curScrollY = window.scrollY;

            if (lastScrollY === curScrollY) {
                window.requestAnimationFrame(rafLoop);
                return;
            }

            // Fire onScroll function if window scrolls vertically.
            onScroll();

            lastScrollY = curScrollY;
            window.requestAnimationFrame(rafLoop);
        };

        // Initialize state based on browser initial scroll position.
        onScroll();
        // Start loop.
        rafLoop();
    }

    /* =================================================
    Mobile nav.
    =================================================== */
    const menuToggle = document.getElementById('menu-toggle');
    const mobileMenuItem = document.querySelectorAll(
        '.menu-mobile .nav__menu .menu-item'
    );
    const body = document.body;

    // Menu Toggle.
    menuToggle.addEventListener('click', function() {
        if (body.classList.contains('menu-mobile-active')) {
            body.classList.remove('menu-mobile-active');
        } else {
            body.classList.add('menu-mobile-active');
        }
    });

    // Mobile Sub Menu.
    const subMenus = document.querySelector('.rs-main-sub-menus');

    Array.from(mobileMenuItem).forEach(menuItem => {
        menuItem.classList.remove('expanded');
        menuItem.addEventListener('click', function() {
            if (this.classList.contains('expanded')) {
                this.classList.remove('expanded');
            } else {
                this.classList.add('expanded');
            }

            // Get menu id from clicked menu item.
            const curentMenuItem = this.dataset.menuid;
            const targetMenuItem = document.querySelector(`[data-submenuid='${curentMenuItem}']`);
            // Find target menu item from submenus.
            if (targetMenuItem) {
                targetMenuItem.classList.add('active');
            }
            // if curent menu item has no child menu, don't open submenu.
            if (curentMenuItem) {
                subMenus.classList.add('rs-main-sub-menus--open');
            }
        });
    });

    // Close Sub Menu
    const closeSub = document.getElementById('btn-close-sub');

    closeSub.addEventListener('click', function() {
        subMenus.classList.remove('rs-main-sub-menus--open');
        const subMenuItems = document.querySelectorAll('.rs-main-sub-menus > .menu-item');
        subMenuItems.forEach((menuItem) => {
            if (menuItem.classList.contains('active')) {
                menuItem.classList.remove('active');
            }
        });
    });

    // TODO: add class if page contains background image as first element
    const backgroundID = document.getElementById('rs-background-image');

    if (document.body.contains(backgroundID)) {
        body.classList.add('has-background-image');
    }

    // Accordion Menu in Desktop
    const accordionMenus = document.querySelectorAll('.menu-item-accordion');

    Array.from(accordionMenus).forEach((menu) => {
        menu.addEventListener('click', function() {
            if (this.classList.contains('active')) {
                this.classList.remove('active');
            } else {
                this.classList.add('active');
            }
        });
    });
})();
